import React, { useState, useEffect, useCallback, createContext } from 'react';
import get from 'lodash.get';
import { connect } from 'react-redux';
import { name as pageName, className } from './__styles__/pageVars.scss';
import { isBrowser } from 'acq-utils/lib/misc';
import { PageWrapper } from 'src/universal/components/PageWrapper';
import LazyScrollMetricTracker from 'src/universal/components/DTM/LazyScrollMetricTracker';
import { pznPageIds } from 'src/universal/components/PZN/config';
import ErrorPage from 'src/universal/components/ErrorPage';
import { InitFetchPageDataHelper } from 'src/universal/redux/utils';
import { isCardMember, isLoggedInCardMember } from 'src/universal/redux/userType';
import dtmEvents from 'service_modules/models/dtm-tagging';
import AlertBanner from 'src/universal/components/AlertBanner';
import SetCardMemberClassName from 'src/universal/components/CardMember/SetCardMemberClassName';
import SetDisplayNameClass from 'page_modules/utils/set-display-name-class';
import LegacyMain from './components/LegacyMain';
import { getPznInfo } from 'src/universal/redux/pznData.js';
import { getVacPageData } from 'page_modules/business-vac/redux/mainPageData';
import { dispatchDtmActions } from 'src/universal/components/DispatchDtmActions';
import { pageLevelBundledCmPznExt } from 'src/universal/utils/orchestraCmPznExtEvent';
import OgSpinner from 'src/universal/components/OfferGatingSpinner';
import {
  hasMemberInfoArrived,
  getMemberCardTitles
} from 'src/universal/redux/cardMemberInfo.js';
import { getOfferStylingPageLoadDtmList } from 'src/universal/utils/offerStyling';
import { doOfferStylingPgEvents } from 'src/universal/utils/offerStyling';
import AmazonModal from './components/AmazonModal/index';
import TrackExperimentImpression from 'src/universal/components/TrackExperimentImpression';

// styles
import './__styles__/navs.scss';
import './__styles__/index.scss';

export const InterstitialModalContext = createContext(null);

const FetchPageDataHelper = new InitFetchPageDataHelper({
  pageName
});

const PageComponent = React.memo(function PageComponent({
  dispatch,
  data = {},
  pgPznId,
  pageData,
  pznInfo,
  isCM,
  cmInfoArrived,
  cardMemberTitles,
  isUserLoggedIn,
  offerStylingPgLoadDtms,
  pznData,
  location
}) {
  const usePZN = true;
  dispatchDtmActions({
    FetchPageDataHelper,
    dispatch,
    data,
    dtmCategoryPaths: [
      'page.dtm.pageName',
      'page.dtm.subCategory2',
      'page.dtm.subCategory3'
    ],
    usePZN,
    pznData,
    isCardMember: isCM,
    hasCMInfoArrived: cmInfoArrived,
    isUserLoggedIn,
    cardTitles: cardMemberTitles
  });

  const [showApplyNow, setShowApplyNow] = useState(false);

  const openApplyNow = useCallback(data => {
    dispatch({ type: 'GET_MODAL_DATA', data });
    setShowApplyNow(true);
  }, []);

  const closeApplyNow = button => {
    dtmEvents.dispatch({ type: 'DTM_CLICK', dtmTag: button.dtmTag });
    dispatch({ type: 'GET_MODAL_DATA', data: {} });
    setShowApplyNow(false);
  };

  useEffect(
    () => {
      if (pznInfo.hasPznArrived) {
        setTimeout(() => {
          pageLevelBundledCmPznExt();
        }, 800);
      }
    },
    [pznInfo.hasPznArrived]
  );

  if (isBrowser() && pznInfo.hasError) {
    return (
      <ErrorPage
        httpStatus={get(pznInfo, 'errorInfo.errorCode')}
        reqUrl={get(pznInfo, 'errorInfo.reqUrl')}
      />
    );
  }

  return (
    <PageWrapper
      displayName={className}
      FetchPageDataHelper={FetchPageDataHelper}
      data={data}
      usePZN={usePZN}
      pznPageId={pgPznId}
      shouldRenderOfferExpiry={true}
      currentURL={location.pathname}
    >
      <LazyScrollMetricTracker
        callBackFunction={() => {
          doOfferStylingPgEvents(offerStylingPgLoadDtms);
        }}
        startTrackingAfterPznArrival={true}
      />
      <TrackExperimentImpression experimentName="GCS-171-ApplyNow-LockIcon-Removal" />
      <AlertBanner maxWidth="940px" />
      <InterstitialModalContext.Provider value={openApplyNow}>
        <LegacyMain pageData={pageData} showOffers={pznInfo.hasPznArrived} />
      </InterstitialModalContext.Provider>
      <AmazonModal showApplyNow={showApplyNow} closeApplyNow={closeApplyNow} />
      <SetCardMemberClassName />
      <SetDisplayNameClass />
      <OgSpinner />
    </PageWrapper>
  );
});

FetchPageDataHelper.pageDataSetup(PageComponent, className);

const mapStateToProps = state => {
  const rawVacData = state[pageName];
  const pznData = state.pznData;

  return {
    data: rawVacData,
    pgPznId: pznPageIds[pageName],
    pageData: getVacPageData(state),
    pznInfo: getPznInfo(state),
    isCM: isCardMember(state),
    cmInfoArrived: hasMemberInfoArrived(state),
    isUserLoggedIn: isLoggedInCardMember(state),
    cardMemberTitles: getMemberCardTitles(state),
    offerStylingPgLoadDtms: getOfferStylingPageLoadDtmList(state),
    pznData
  };
};

export default connect(mapStateToProps)(PageComponent);
